import { Certificate } from './certificate';
import { RsaProviderInfo } from './rsaProviderInfo';

export interface RsaServiceHistoryEntry {
  comment: string;
  actionedBy: string;
  modifiedTime: Date;
  modifiedStatus: string;
}

export class RsaProvided {
    city: string;
    dealershipLocation: string;
    provider: string;
    reimbursementAmount?: number;
    reimbursementComment?: string;
    distance: number;
    serviceCost: number;
    serviceStatus: string;
    paidBy: string;
    callbackNumber: number;
    callerName: string;
    rsaProvidedDate: Date;
    rsaProvideInstanceNumber: number;
    certificateNumber: string;

    // New fields
    certificate: Certificate; // full certificate data
    rsaProvidedBy?: RsaProviderInfo; // full provider data if selected
    history: RsaServiceHistoryEntry[] = [];

    public constructor(init?: Partial<RsaProvided>) {
        Object.assign(this, init);
    }
}